"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbEventBus = void 0;
const features_1 = require("../../features");
class MbEventBus {
    constructor() {
        this.eventBus = (0, features_1.getGlobalEventBus)() || this.initEventBus();
    }
    initEventBus() {
        (0, features_1.initGlobalEventBus)();
        return (0, features_1.getGlobalEventBus)();
    }
    static getGlobalEventBus() {
        if (!MbEventBus.instance) {
            MbEventBus.instance = new MbEventBus();
        }
        return MbEventBus.instance;
    }
    publish(type, event) {
        this.eventBus.publish(type, event);
    }
    subscribe(type, listener, receiveLastPublished = false) {
        return this.eventBus.subscribe(type, listener, receiveLastPublished);
    }
}
exports.MbEventBus = MbEventBus;
//# sourceMappingURL=index.js.map